<template>
  <!-- 电脑端 -->
  <div class="home" v-if="!isMobile">
    <div class="img-bg posRelative" @contextmenu.prevent="disableContextMenu">
      <video :src="videoUrl" class="posAbsoluteAll objFitFill" autoplay loop :muted="isMuted"></video>
      <div>
        <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/laba2.png" class="img-laba anim-bigger-small"
             v-if="isMuted"
             @click.stop="isMuted=false">
        <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/laba1.png" class="img-laba anim-bigger-small"
             v-else @click.stop="isMuted=true">
      </div>
    </div>

    <div>
      <!-- 经营业务 -->
      <div ref="part1" class="part1" :class="{ 'bottom-to-top-anim': showPart1Anim }">
        <div class="row-me row-center margin-top100">
          <div>
            <div class="font-size40 font-bold" v-if="language==='0'">经营业务</div>
            <div class="font-size40 font-bold" v-if="language==='1'">What we do</div>
            <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/chenglong.png" class="img-title"
                 draggable="false">
          </div>
          <div class="flex1"></div>
          <div class="row-me center-all look-div pointer" @click="clickPath('/case')" @mouseenter="nowIndex=1"
               @mouseleave="nowIndex=0">
            <span v-if="language==='0'">查看详情</span>
            <span v-if="language==='1'">Discover More</span>
            <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/zk2.png"
                 class="img20 objScaleDown margin-left10" draggable="false" v-if="nowIndex===1">
            <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/zk1.png"
                 class="img20 objScaleDown margin-left10" draggable="false" v-else>
          </div>
        </div>
        <div class="row-me height434 margin-top60">
          <div class="posRelative" :class="{'width575':businessIndex===index,'flex1':businessIndex!==index}"
               v-for="(item, index) in businessArray" :key="index" @mouseenter="mouseenter(index)">
            <img :src="item.img" class="wh100P objFitCover" draggable="false">
            <div class="mask"></div>
            <div class="label-div">
              <img :src="item.icon" class="img24 objScaleDown" draggable="false">
              <div class="font-size20 font-bold colorfff margin-top10">{{ item.title }}</div>
              <div class="font-size14 colorfff margin-top10">{{ item.title_en }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 我们的优势 -->
      <div ref="part2" class="part2" :class="{ 'bottom-to-top-anim': showPart2Anim }">
        <div class="row-me row-center margin-top100">
          <div>
            <div class="font-size40 font-bold" v-if="language==='0'">我们的优势</div>
            <div class="font-size40 font-bold" v-if="language==='1'">Advantages</div>
            <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/chenglong.png" class="img-title"
                 draggable="false">
          </div>
        </div>
        <div class="row-me margin-top60 padding-bottom100">
          <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/img_youshi.png" class="img-icon objFitCover"
               draggable="false">
          <div class="flex1 column-me margin-left30" v-if="language==='0'">
            <div class="row-me row-center flex1 bgcF6F6EF">
              <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_gylws.png"
                   class="img88 margin-left30" draggable="false">
              <div class="flex1 margin-left23">
                <div class="font-size30">供应链完善</div>
                <div class="font-size18 margin-top20">立足国际市场，精选优质货源，形成长期稳定的货物供应链。</div>
              </div>
            </div>
            <div class="row-me row-center flex1 bgcF6F6EF mTB20">
              <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_psgx.png" class="img88 margin-left30"
                   draggable="false">
              <div class="flex1 margin-left23">
                <div class="font-size30">配送高效</div>
                <div class="font-size18 margin-top20">与国际一流货运公司合作，携手打造安全高效的物流网，海陆空路路畅通。
                </div>
              </div>
            </div>
            <div class="row-me row-center flex1 bgcF6F6EF">
              <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_shbz.png" class="img88 margin-left30"
                   draggable="false">
              <div class="flex1 margin-left23">
                <div class="font-size30">售后保障</div>
                <div class="font-size18 margin-top20">我们以完善的售后保障体系，为客户的交易流程提供全方位保障。</div>
              </div>
            </div>
          </div>
          <div class="flex1 column-me margin-left30" v-if="language==='1'">
            <div class="row-me row-center flex1 bgcF6F6EF">
              <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_gylws.png"
                   class="img88 margin-left30" draggable="false">
              <div class="flex1 margin-left23">
                <div class="font-size30">Well-established supply chain</div>
                <div class="font-size18 margin-top20">
                  Establish international market,
                  select high-quality supply,
                  form long-term and stable supply chains of goods.
                </div>
              </div>
            </div>
            <div class="row-me row-center flex1 bgcF6F6EF mTB20">
              <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_psgx.png" class="img88 margin-left30"
                   draggable="false">
              <div class="flex1 margin-left23">
                <div class="font-size30">Efficient distribution</div>
                <div class="font-size18 margin-top20">
                  Cooperate with world-class shipping company，
                  create a secure and efficient logistics network，making sea, land and air transportation unimpeded.
                </div>
              </div>
            </div>
            <div class="row-me row-center flex1 bgcF6F6EF">
              <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_shbz.png" class="img88 margin-left30"
                   draggable="false">
              <div class="flex1 margin-left23">
                <div class="font-size30">Aftermarket</div>
                <div class="font-size18 margin-top20">
                  We offer all-round protection of transaction process with perfect after-sales service.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 全球业务布局 -->
      <div ref="part3" class="part3" :class="{ 'bottom-to-top-anim': showPart3Anim }">
        <div class="row-me row-center">
          <div class="flex1">
            <div>
              <div class="font-size40 font-bold colorfff" v-if="language==='0'">全球业务布局</div>
              <div class="font-size40 font-bold colorfff" v-if="language==='1'">Global business layout</div>
              <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/chenglong1.png" class="img-title"
                   draggable="false">
            </div>
            <div class="font-size18 lineH40 colorfff margin-top50 width780" v-if="language==='0'">
              呈龙集团将全球化市场视为重要机遇，紧跟客户需求，为客户提供优质的服务；同俄罗斯、白俄罗斯、哈萨克斯坦、土耳其、巴西等多个海外国家都有长期合作关系。
              <br>
              呈龙集团致力于向客户提供最优质的产品，并且我们具备国际化和多语言的业务团队，凭借丰富的属地知识和业务经验，可在全球复杂环境中为国内大客户在海外采购提供一流的综合服务。我们诚挚邀请国内外志同道合有识之士携手合作，共同促进大宗贸易商品的发展，打造比以往更专业、更安全、更贴心、更高品质的服务。
            </div>
            <div class="font-size18 lineH40 colorfff margin-top50 width780" v-if="language==='1'">
              CHENGLONG GROUP views globalized markets as an important opportunity,keeps abreast of customer
              needs,providing superior service and product for clients.CHENGLONG GROUP has long-term cooperation
              relations with Russia, Belarus, Kazakhstan, Turkey, Brazil and other overseas countries.
              <br>
              CHENGLONG GROUP Commits to providing customers with the highest quality products and we have an
              international and multilingual business team.With extensive territorial knowledge and business
              experience,we can provide best-in-class integrated services for large domestic customers purchasing
              overseas in complex environments around the world.We sincerely invite like-minded people at home and
              abroad to work together,jointly promote the development of commodity trade and create more professional,
              safer, more intimate, higher quality services than ever before.
            </div>
            <div class="row-me row-center margin-top60 colorfff">
              <div>
                <div class="font-size16" v-if="language==='0'">
                  <span class="font-size60 font-bold margin-right10">2008</span>年
                </div>
                <div class="font-size16" v-if="language==='1'">
                  <span class="font-size60 font-bold margin-right10">2008</span>Y
                </div>
                <div class="row-me row-center margin-top8">
                  <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_clsj1.png" class="img24"
                       draggable="false">
                  <div class="font-size18 margin-left10" v-if="language==='0'">公司成立年份</div>
                  <div class="font-size18 margin-left10 keep-all" v-if="language==='1'">The company was founded in
                    2008
                  </div>
                </div>
              </div>
              <div class="line-shu mLR60"></div>
              <div>
                <div class="font-size16" v-if="language==='0'">
                  <span class="font-size60 font-bold margin-right10">6</span>个
                </div>
                <div class="font-size16" v-if="language==='1'">
                  <span class="font-size60 font-bold margin-right10">6</span>P
                </div>
                <div class="row-me row-center margin-top8">
                  <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_hzjg.png" class="img24"
                       draggable="false">
                  <div class="font-size18 margin-left10" v-if="language==='0'">国外合作机构</div>
                  <div class="font-size18 margin-left10 keep-all" v-if="language==='1'">6 overseas collaborators</div>
                </div>
              </div>
              <div class="line-shu mLR60"></div>
              <div>
                <div class="font-size16" v-if="language==='0'">
                  <span class="font-size60 font-bold margin-right10">20</span>个
                </div>
                <div class="font-size16" v-if="language==='1'">
                  <span class="font-size60 font-bold margin-right10">20</span>P
                </div>
                <div class="row-me row-center margin-top8">
                  <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_ckg.png" class="img24"
                       draggable="false">
                  <div class="font-size18 margin-left10" v-if="language==='0'">产品出口国家</div>
                  <div class="font-size18 margin-left10 keep-all" v-if="language==='1'">20 product expoters</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row-me center-all margin-left200">
            <div id="main"></div>
          </div>
        </div>
      </div>

      <!-- 新闻中心 -->
      <div ref="part4" class="part4" :class="{ 'bottom-to-top-anim': showPart4Anim }">
        <div class="row-me row-center margin-top100">
          <div>
            <div class="font-size40 font-bold" v-if="language==='0'">新闻中心</div>
            <div class="font-size40 font-bold" v-if="language==='1'">News</div>
            <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/chenglong.png" class="img-title"
                 draggable="false">
          </div>
          <div class="flex1"></div>
          <div class="row-me center-all look-div pointer" @click="clickPath('/news')" @mouseenter="nowIndex=2"
               @mouseleave="nowIndex=0">
            <span v-if="language==='0'">查看详情</span>
            <span v-if="language==='1'">Discover More</span>
            <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/zk2.png"
                 class="img20 objScaleDown margin-left10" draggable="false" v-if="nowIndex===2">
            <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/zk1.png"
                 class="img20 objScaleDown margin-left10" draggable="false" v-else>
          </div>
        </div>
        <div class="row-me flex-wrap margin-top60 padding-bottom80">
          <div class="item-news column-me" v-for="(item, index) in newsArray" :key="index" @click="clickNews(item)">
            <img :src="item.img" class="item-img objFitCover" draggable="false">
            <div class="flex1 bgcF4F4F4 padding30">
              <div class="font-size24 line1 color000 title1" v-if="language==='0'">{{ item.title }}</div>
              <div class="font-size24 line1 color000 title1" v-if="language==='1'">{{ item.title_en }}</div>
              <div class="font-size18 color666 margin-top10">{{ item.date }}</div>
              <div class="font-size18 color666 lineH30 line2 margin-top30">{{ item.contents }}</div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- 手机端 -->
  <div class="home-mobile" v-else>
    <div class="img-bg posRelative" @contextmenu.prevent="disableContextMenu">
      <video :src="videoUrl" class="posAbsoluteAll objFitFill" autoplay loop :muted="isMuted"
             :webkit-playsinline='true' :playsinline='true' v-if="showVideo"></video>
      <div>
        <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/laba2.png" class="img-laba anim-bigger-small"
             v-if="isMuted"
             @click.stop="isMuted=false">
        <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/laba1.png" class="img-laba anim-bigger-small"
             v-else @click.stop="isMuted=true">
      </div>
    </div>

    <div>
      <!-- 经营业务 -->
      <div ref="part1" class="part1" :class="{ 'bottom-to-top-anim': showPart1Anim }">
        <div class="row-me row-center margin-top50">
          <div>
            <div class="font-size40 font-bold" v-if="language==='0'">经营业务</div>
            <div class="font-size40 font-bold" v-if="language==='1'">What we do</div>
            <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/chenglong.png" class="img-title"
                 draggable="false">
          </div>
          <div class="flex1"></div>
          <div class="row-me center-all look-div pointer" @click="clickPath('/case')" @mouseenter="nowIndex=1"
               @mouseleave="nowIndex=0">
            <span v-if="language==='0'">查看详情</span>
            <span v-if="language==='1'">Discover More</span>
            <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/zk2.png"
                 class="width18 height5 margin-left10" draggable="false" v-if="nowIndex===1">
            <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/zk1.png"
                 class="width18 height5 margin-left10" draggable="false" v-else>
          </div>
        </div>
        <div class="row-me flex-wrap margin-top60">
          <div class="posRelative width335 height200 margin-right20 mR0-2 margin-bottom40"
               v-for="(item, index) in businessArray" :key="index" @mouseenter="mouseenter(index)">
            <img :src="item.img" class="wh100P objFitCover" draggable="false">
            <div class="mask"></div>
            <div class="label-div">
              <img :src="item.icon" class="img24" draggable="false">
              <div class="font-size20 font-bold colorfff margin-top10">{{ item.title }}</div>
              <div class="font-size14 colorfff margin-top10">{{ item.title_en }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 我们的优势 -->
      <div ref="part2" class="part2" :class="{ 'bottom-to-top-anim': showPart2Anim }">
        <div class="row-me row-center margin-top80">
          <div>
            <div class="font-size40 font-bold" v-if="language==='0'">我们的优势</div>
            <div class="font-size40 font-bold" v-if="language==='1'">Advantages</div>
            <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/chenglong.png" class="img-title"
                 draggable="false">
          </div>
        </div>
        <div class="row-me margin-top60 padding-bottom100">
          <div class="flex1 column-me" v-if="language==='0'">
            <div class="row-me row-center flex1 bgcF6F6EF pTB30">
              <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_gylws.png"
                   class="img88 margin-left30" draggable="false">
              <div class="flex1 margin-left23">
                <div class="font-size30">供应链完善</div>
                <div class="font-size18 margin-top20">立足国际市场，精选优质货源，形成长期稳定的货物供应链。</div>
              </div>
            </div>
            <div class="row-me row-center flex1 bgcF6F6EF mTB20 pTB30">
              <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_psgx.png" class="img88 margin-left30"
                   draggable="false">
              <div class="flex1 margin-left23">
                <div class="font-size30">配送高效</div>
                <div class="font-size18 margin-top20">与国际一流货运公司合作，携手打造安全高效的物流网，海陆空路路畅通。
                </div>
              </div>
            </div>
            <div class="row-me row-center flex1 bgcF6F6EF pTB30">
              <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_shbz.png" class="img88 margin-left30"
                   draggable="false">
              <div class="flex1 margin-left23">
                <div class="font-size30">售后保障</div>
                <div class="font-size18 margin-top20">我们以完善的售后保障体系，为客户的交易流程提供全方位保障。</div>
              </div>
            </div>
          </div>
          <div class="flex1 column-me" v-if="language==='1'">
            <div class="row-me row-center flex1 bgcF6F6EF pTB30">
              <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_gylws.png"
                   class="img88 margin-left30" draggable="false">
              <div class="flex1 margin-left23">
                <div class="font-size30">Well-established supply chain</div>
                <div class="font-size18 margin-top20">
                  Establish international market,
                  select high-quality supply,
                  form long-term and stable supply chains of goods.
                </div>
              </div>
            </div>
            <div class="row-me row-center flex1 bgcF6F6EF mTB20 pTB30">
              <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_psgx.png" class="img88 margin-left30"
                   draggable="false">
              <div class="flex1 margin-left23">
                <div class="font-size30">Efficient distribution</div>
                <div class="font-size18 margin-top20">
                  Cooperate with world-class shipping company，
                  create a secure and efficient logistics network，making sea, land and air transportation unimpeded.
                </div>
              </div>
            </div>
            <div class="row-me row-center flex1 bgcF6F6EF pTB30">
              <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_shbz.png" class="img88 margin-left30"
                   draggable="false">
              <div class="flex1 margin-left23">
                <div class="font-size30">Aftermarket</div>
                <div class="font-size18 margin-top20">
                  We offer all-round protection of transaction process with perfect after-sales service.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 全球业务布局 -->
      <div ref="part3" class="part3" :class="{ 'bottom-to-top-anim': showPart3Anim,'part3-bg':isIOS }">
        <div>
          <div class="font-size40 font-bold colorfff" v-if="language==='0'">全球业务布局</div>
          <div class="font-size40 font-bold colorfff" v-if="language==='1'">Global business layout</div>
          <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/chenglong1.png" class="img-title"
               draggable="false">
        </div>
        <div class="row-me row-center">
          <div class="flex1 colorfff">
            <div class="margin-top50">
              <div class="font-size16" v-if="language==='0'"><span
                  class="font-size60 font-bold margin-right10">2008</span>年
              </div>
              <div class="font-size16" v-if="language==='1'"><span
                  class="font-size60 font-bold margin-right10">2008</span>Y
              </div>
              <div class="row-me row-center margin-top8">
                <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_clsj1.png" class="img24"
                     draggable="false">
                <div class="font-size18 margin-left10" v-if="language==='0'">公司成立年份</div>
                <div class="font-size18 margin-left10 keep-all" v-if="language==='1'">The company was founded in 2008
                </div>
              </div>
            </div>
            <div class="margin-top50">
              <div class="font-size16" v-if="language==='0'">
                <span class="font-size60 font-bold margin-right10">6</span>个
              </div>
              <div class="font-size16" v-if="language==='1'">
                <span class="font-size60 font-bold margin-right10">6</span>P
              </div>
              <div class="row-me row-center margin-top8">
                <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_hzjg.png" class="img24"
                     draggable="false">
                <div class="font-size18 margin-left10" v-if="language==='0'">国外合作机构</div>
                <div class="font-size18 margin-left10 keep-all" v-if="language==='1'">6 overseas collaborators</div>
              </div>
            </div>
            <div class="margin-top50">
              <div class="font-size16" v-if="language==='0'">
                <span class="font-size60 font-bold margin-right10">20</span>个
              </div>
              <div class="font-size16" v-if="language==='1'">
                <span class="font-size60 font-bold margin-right10">20</span>P
              </div>
              <div class="row-me row-center margin-top8">
                <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_ckg.png" class="img24"
                     draggable="false">
                <div class="font-size18 margin-left10" v-if="language==='0'">产品出口国家</div>
                <div class="font-size18 margin-left10 keep-all" v-if="language==='1'">20 product expoters</div>
              </div>
            </div>
          </div>
          <div class="row-me center-all">
            <div id="main">
              <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/earth.png" class="wh100P"
                   draggable="false" v-if="isIOS">
            </div>
          </div>
        </div>
        <div class="font-size26 lineH50 colorfff margin-top90" v-if="language==='0'">
          呈龙集团将全球化市场视为重要机遇，紧跟客户需求，为客户提供优质的服务；同俄罗斯、白俄罗斯、哈萨克斯坦、土耳其、巴西等多个海外国家都有长期合作关系。
          <br>
          呈龙集团致力于向客户提供最优质的产品，并且我们具备国际化和多语言的业务团队，凭借丰富的属地知识和业务经验，可在全球复杂环境中为国内大客户在海外采购提供一流的综合服务。我们诚挚邀请国内外志同道合有识之士携手合作，共同促进大宗贸易商品的发展，打造比以往更专业、更安全、更贴心、更高品质的服务。
        </div>
        <div class="font-size26 lineH50 colorfff margin-top90" v-if="language==='1'">
          CHENGLONG GROUP views globalized markets as an important opportunity,keeps abreast of customer
          needs,providing superior service and product for clients.CHENGLONG GROUP has long-term cooperation
          relations with Russia, Belarus, Kazakhstan, Turkey, Brazil and other overseas countries.
          <br>
          CHENGLONG GROUP Commits to providing customers with the highest quality products and we have an
          international and multilingual business team.With extensive territorial knowledge and business
          experience,we can provide best-in-class integrated services for large domestic customers purchasing
          overseas in complex environments around the world.We sincerely invite like-minded people at home and
          abroad to work together,jointly promote the development of commodity trade and create more professional,
          safer, more intimate, higher quality services than ever before.
        </div>
      </div>

      <!-- 新闻中心 -->
      <div ref="part4" class="part4" :class="{ 'bottom-to-top-anim': showPart4Anim }">
        <div class="row-me row-center margin-top50">
          <div>
            <div class="font-size40 font-bold" v-if="language==='0'">新闻中心</div>
            <div class="font-size40 font-bold" v-if="language==='1'">News</div>
            <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/chenglong.png" class="img-title"
                 draggable="false">
          </div>
          <div class="flex1"></div>
          <div class="row-me center-all look-div pointer" @click="clickPath('/news')" @mouseenter="nowIndex=2"
               @mouseleave="nowIndex=0">
            <span v-if="language==='0'">查看详情</span>
            <span v-if="language==='1'">Discover More</span>
            <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/zk2.png"
                 class="width18 height5 margin-left10" draggable="false" v-if="nowIndex===2">
            <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/zk1.png"
                 class="width18 height5 margin-left10" draggable="false" v-else>
          </div>
        </div>
        <div class="margin-top60 padding-bottom80">
          <el-carousel indicator-position="outside" arrow="always">
            <el-carousel-item v-for="(item, index) in newsArray" :key="index">
              <div class="item-news column-me" @click="clickNews(item)">
                <img :src="item.img" class="item-img objFitCover" draggable="false">
                <div class="flex1 bgcF4F4F4 padding30">
                  <div class="font-size30 line1 color000 title1" v-if="language==='0'">{{ item.title }}</div>
                  <div class="font-size30 line1 color000 title1" v-if="language==='1'">{{ item.title_en }}</div>
                  <div class="font-size24 color666 margin-top10">{{ item.date }}</div>
                  <div class="font-size24 color666 lineH30 line2 margin-top30">
                    {{ item.contents }}
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import "echarts-gl";
import neData from "@/assets/js/data.json";
import world from "@/assets/js/world.json";
import index from "vuex";

export default {
  components: {},
  data() {
    return {
      showPart1Anim: false,
      showPart2Anim: false,
      showPart3Anim: false,
      showPart4Anim: false,
      newsArray: [], //新闻资讯
      hoverIndex: null,
      detailItem: null,
      baseTexture: null,
      isMuted: true, //视频是否静音
      language: "", //0中文，1英文
      isMobile: "", //0电脑，1手机
      tabIndex: 1, //1行业新闻  2内部信息
      numTxt: 0,
      videoUrl: "https://chenglong-web.oss-cn-qingdao.aliyuncs.com/home.mp4?v=" + new Date().getTime(),
      businessArray: [],//经营业务
      businessIndex: 0,
      nowIndex: 0,
      isIOS: false,
      showVideo: false,
    }
  },
  watch: {
    scrollTop: {
      handler: function (newVal, oldVal) {
        if (this.language === '0') {
          if (!this.$method.isElementNotInViewport(this.$refs["part1"]) && !this.isMobile) {
            this.showPart1Anim = true;
          }
          if (!this.$method.isElementNotInViewport(this.$refs["part2"]) && !this.isMobile) {
            this.showPart2Anim = true;
          }
          if (!this.$method.isElementNotInViewport(this.$refs["part3"]) && !this.isMobile) {
            this.showPart3Anim = true;
          }
          if (!this.$method.isElementNotInViewport(this.$refs["part4"]) && !this.isMobile) {
            this.showPart4Anim = true;
          }
        }
      },
    },
  },
  computed: {
    index() {
      return index
    },
    scrollTop() {
      return this.$store.state.scrollTop;
    },
    navItem() {
      return this.$store.state.navItem;
    },
  },
  created() {
    const userAgent = navigator.userAgent.toLowerCase();
    this.isIOS = /iphone|ipad|ipod/.test(userAgent);
    this.isMobile = sessionStorage.getItem("mobile") === "1";
    this.language = sessionStorage.getItem("language");
    document.title = this.navItem.name;
    this.businessArray = [
      {
        title: '冶金',
        title_en: 'Metallurgy',
        img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/img_yj.png',
        icon: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_yj.png',
      },
      {
        title: '能化',
        title_en: 'Energy and Chemical Industry',
        img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/img_nh.png',
        icon: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_nh.png',
      },
      {
        title: '有色',
        title_en: 'Nonferrous Metallurgical',
        img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/img_ys.png',
        icon: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_ys.png',
      },
      {
        title: '纺织',
        title_en: 'Textile',
        img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/img_fz.png',
        icon: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_fz.png',
      },
      {
        title: '浆纸',
        title_en: 'Pulp',
        img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/img_jz.png',
        icon: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_jz.png',
      },
      {
        title: '农产',
        title_en: 'Agriculture',
        img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/img_nc.png',
        icon: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_nc.png',
      },
      {
        title: '冻品',
        title_en: 'Frozen Goods',
        img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/img_dp.png',
        icon: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_dp.png',
      },
      {
        title: '新媒体',
        title_en: 'New Media',
        img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/img_xmt.png',
        icon: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_xmt.png',
      },
    ]
  },
  activated() {
    this.language = sessionStorage.getItem("language");
    document.title = this.navItem.name;
    this.showPart1Anim = false;
    this.showPart2Anim = false;
    this.showPart3Anim = false;
    this.showPart4Anim = false;
    // 以下解决手机端菜单切回首页视频不自动播放问题
    this.showVideo = false
    setTimeout(() => {
      this.showVideo = true
    }, 100)
  },
  mounted() {
    this.getNews();
    if (!this.isIOS) {
      this.resetHandle = this.debounce(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 100)
      window.addEventListener('resize', this.resetHandle)
      this.getBaseTexture();
    }
  },
  methods: {
    disableContextMenu(event) {
      event.preventDefault();
    },
    mouseenter(index) {
      this.businessIndex = index
    },
    clickPath(path) {
      this.$router.push({
        path: path
      })
    },
    debounce(func, wait, immediate) {
      let timeout, args, context, timestamp, result
      const later = function () {
        // 据上一次触发时间间隔
        const last = +new Date() - timestamp
        // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
        if (last < wait && last > 0) {
          timeout = setTimeout(later, wait - last)
        } else {
          timeout = null
          // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
          if (!immediate) {
            result = func.apply(context, args)
            if (!timeout) context = args = null
          }
        }
      }
      return function (...args) {
        context = this
        timestamp = +new Date()
        const callNow = immediate && !timeout
        // 如果延时不存在，重新设定延时
        if (!timeout) timeout = setTimeout(later, wait)
        if (callNow) {
          result = func.apply(context, args)
          context = args = null
        }
        return result
      }
    },
    getBaseTexture() {
      let canvas = document.createElement('canvas');
      if (this.language == 0) {
        echarts.registerMap("world", neData);
      } else {
        echarts.registerMap("world", world);
      }
      this.baseTexture = echarts.init(canvas, null, {
        width: 4096,
        height: 2048,
      });
      this.baseTexture.setOption({
        backgroundColor: "#031c48",
        geo: {
          type: "map",
          map: "world",
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
          boundingCoords: [
            [-180, 90],
            [180, -90],
          ],
          roam: false,
          itemStyle: {
            normal: {
              areaColor: "#2455ad",
              borderColor: "#000c2d",
            },
            emphasis: {
              areaColor: "#357cf8",
            },
          },
          label: {
            normal: {
              fontSize: 20,
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
            emphasis: {
              fontSize: 30,
              show: true,
              textStyle: {
                color: "yellow",
              },
            },
          },
        },
      });
      this.drawEarth();
      // 获取元素
      // 地球数据显示
    },
    drawEarth() {
      var _this = this;
      // var wayBtn = '';
      // if(){}
      _this.chart = echarts.init(document.getElementById('main'))
      let option = {
        backgroundColor: "#013954",
        tooltip: {
          show: true, //是否开启提示层
          transitionDuration: 0, // 提示框浮层的移动动画过渡时间
          // 鼠标是否可以进入悬浮框
          enterable: true,
          // 触发方式 mousemove, click, none, mousemove|click  点击地球	点击触发
          triggerOn: "click",
          // item 图形触发， axis 坐标轴触发， none 不触发
          trigger: "item",
          // 浮层隐藏的延迟
          hideDelay: 100,
          // 背景色
          backgroundColor: "rgba(0,0,0,0.5)",
          formatter: function (params) {
            return (
                '<div class="chartLabel">' +
                "<div class=title>" +
                params.data.nameTxt + "：" +
                params.data.name +
                "</div>" +
                "<div class=title>" +
                params.data.emailTxt + "：" +
                params.data.email +
                "</div>" +
                "<div class=title>" +
                params.data.faxTxt + "：" +
                params.data.fax +
                "</div>" +
                "<div class=title>" +
                params.data.telTxt + "：" +
                params.data.phone +
                "</div>" +
                "<div class=title>" +
                params.data.addressTxt + "：" +
                params.data.address +
                "</div>" +
                "</div>"
            );
          },
        },
        globe: {
          baseTexture: _this.baseTexture, // 基础纹理
          globeRadius: 150, // 球面半径
          environment: "#0664C8",
          shading: "color",
          light: {
            // 光照阴影
            main: {
              color: "#fff", // 光照颜色
              intensity: 1, // 光照强度
              alpha: 40,
              beta: -30,
            },
            ambient: {
              color: "#fff",
              intensity: 1,
            },
          },
          viewControl: {
            alpha: 30,
            beta: 160,
            autoRotate: true, // 开启自动旋转
            autoRotateAfterStill: 10,
            distance: 240,
          },
        },
        series: [{
          // 点
          type: "scatter3D",
          blendMode: "lighter",
          coordinateSystem: "globe",
          showEffectOn: "render",
          zlevel: 2,
          effectType: "ripple",
          symbolSize: 15,
          rippleEffect: {
            period: 4,
            scale: 4,
            brushType: "fill",
          },

          hoverAnimation: true,
          itemStyle: {
            normal: {
              color: "rgba(235, 232, 6, 0.8)",
              // borderWidth: 0
            },
          },
          label: {
            show: false, //自己的提示层
            formatter: "{b}",
            distance: 5000000, //距离--设置大点。不要这个
            position: "right",
            textStyle: {
              fontSize: 14,
              fontWeight: "normal",
              fontFamily: "Microsoft YaHei",
              color: "#fff",
              borderRadius: 2,
              backgroundColor: "rgba(0,0,0,0.5)",
            },
          },
          data: _this.list,
        },],
      };
      _this.chart.clear();
      _this.chart.setOption(option, true);
      _this.chart.resize();
    },
    //新闻资讯
    clickNews(item) {
      this.$router.push({
        path: "/news",
        query: {
          id: item.id,
        },
      });
    },
    setHoverIndex(index) {
      this.hoverIndex = index;
    },
    clearHoverIndex() {
      this.hoverIndex = null;
    },
    //获取数据
    getNews() {
      this.$getRequest("/api/newsList", {
        page: 1,
        rows: 10,
      }).then((res) => {
        if (res) {
          this.total = res.data.total;
          res.data.data.forEach((item, index) => {
            item.contents = item.contents.replace(/&nbsp;/g, '');
            item.contents = item.contents.replace(/&mdash;/g, '');
            item.contents = item.contents.replace(/\s/g, '');
            item.contents_en = item.contents_en.replace(/&nbsp;/g, '');
            item.contents_en = item.contents_en.replace(/&mdash;/g, '');
            item.contents_en = item.contents_en.replace(/\s/g, '');
            item.date = item.created_at.split(" ")[0]
          });
          this.newsArray = res.data.data.splice(0, 3)
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  .img-bg {
    width: 100%;
    height: 750px;
  }

  .part1 {
    padding: 0 200px;

    .label-div {
      position: absolute;
      left: 30px;
      bottom: 30px;
    }
  }

  .part2 {
    padding: 0 200px;

    .img-icon {
      width: 561px;
      height: 544px;
    }
  }

  .part3 {
    padding: 140px 200px;
    background-color: #0465C8;

    #main {
      width: 520px;
      height: 520px;
    }
  }

  .part4 {
    padding: 0 200px;

    .item-news {
      width: 473px;
      margin-right: 50px;
      margin-bottom: 30px;
      cursor: pointer;

      &:nth-child(3n) {
        margin-right: 0;
      }

      &:hover {
        .title1 {
          color: #D60110;
        }
      }

      .item-img {
        width: 100%;
        height: 270px;
      }
    }
  }

  .look-div {
    padding: 0 15px;
    line-height: 40px;
    text-align: center;
    border-radius: 20px;
    border: 1px solid #BFBFBF;
    font-size: 16px;
    color: #666666;

    &:hover {
      background: #D60110;
      color: #FFFFFF;
      border: 1px solid #D60110;
    }
  }

  .img-title {
    width: 362px;
    height: 66px;
    margin-top: -22px;
  }

  .lineTxt {
    word-break: break-all;
    word-wrap: break-word;
  }
}

.home-mobile {
  .img-laba {
    width: 60px;
    height: 60px;
    object-fit: cover;
    position: absolute;
    bottom: 5%;
    right: 3%;
    cursor: pointer;
  }

  .img-bg {
    width: 100%;
    height: 560px;
  }

  .part1 {
    padding: 0 30px;

    .label-div {
      position: absolute;
      left: 30px;
      bottom: 30px;
    }
  }

  .part2 {
    padding: 0 30px;

    .img-icon {
      width: 561px;
      height: 544px;
    }
  }

  .part3 {
    padding: 50px 30px;
    background-color: #0465C8;

    #main {
      width: 397px;
      height: 397px;
    }
  }

  .part3-bg {
    background-image: url("https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/bg_qqwl.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .part4 {
    padding: 0 30px;

    &:deep(.el-carousel__container) {
      height: 637px;
    }

    &:deep(.el-carousel__button) {
      width: 12px;
      height: 12px;
      margin: 5px;
      border-radius: 50%;
      background: #BFBFBF;
      opacity: 1;
    }

    &:deep(.is-active .el-carousel__button) {
      background: #D60110;
    }

    &:deep(.el-carousel__arrow) {
      width: 60px;
      height: 60px;
      background: rgba(31, 45, 61, 0.6);
      top: 30%;
      font-size: 30px;
      padding-top: 7px;
    }

    .item-news {
      width: 100%;
      height: 637px;

      .item-img {
        width: 100%;
        height: 395px;
      }
    }
  }

  .look-div {
    padding: 0 15px;
    line-height: 50px;
    text-align: center;
    border-radius: 25px;
    border: 1px solid #BFBFBF;
    font-size: 22px;
    color: #666666;

    &:hover {
      background: #D60110;
      color: #FFFFFF;
      border: 1px solid #D60110;
    }
  }

  .img-title {
    width: 362px;
    height: 66px;
    margin-top: -22px;
  }

  .lineTxt {
    word-break: break-all;
    word-wrap: break-word;
  }
}
</style>
